import React, { PureComponent, Suspense } from 'react';
import Spinner from 'react-bootstrap/Spinner';

interface Props { };
interface State { };

export default class Loader extends PureComponent<Props, State> {

    public render(): JSX.Element {
        return <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
        </Spinner>;
    }
}

export const lazyLoad = (
    ComponentToLoad: any,
    loaderProps?: Props,
) => (props: any) => withSuspense(<ComponentToLoad {...props} />, loaderProps);

export const withSuspense = (
    ComponentToLoad: JSX.Element,
    loaderProps?: Props,
) => <Suspense fallback={<Loader {...loaderProps}></Loader>}>
        {ComponentToLoad}
    </Suspense>;

